export default class extends HTMLElement {
  connectedCallback () {
    this.addEventListener('mouseover', this.onMouseover)
    this.addEventListener('click', this.onClick)

    if (this.dataset.urlHash) {
      window.addEventListener('hashchange', this.onHashchange)

      this.onHashchange()
    }
  }

  disconnectedCallback () {
    this.removeEventListener('mouseover', this.onMouseover)
    this.removeEventListener('click', this.onClick)
    window.removeEventListener('hashchange', this.onHashchange)
  }

  onHashchange = () => {
    if (window.location.hash === `#${this.dataset.urlHash}`) {
      this.onClick()
    }
  }

  onMouseover = () => {
    this.load().catch(() => {})
  }

  onClick = () => {
    this.load().then((html) => {
      document.body.insertAdjacentHTML('beforeend', html)
    })
  }

  load () {
    this.loadPromise ||= fetch(this.dataset.src).then((resp) => {
      if (!resp.ok) {
        throw new Error(resp.statusText)
      }

      return resp.text()
    }).catch((error) => {
      this.loadPromise = null

      throw error
    })

    return this.loadPromise
  }
}
